// extracted by mini-css-extract-plugin
export default {"trigger":"trigger_trigger__ryWbI","trigger_icone":"trigger_trigger_icone__n3OJq"};